/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileWorkflowDetailStep } from './fileWorkflowDetailStep';
import { FileWorkflowPermissions } from './fileWorkflowPermissions';
import { FileWorkflowMyStep } from './fileWorkflowMyStep';
import { FileWorkflowDetailFile } from './fileWorkflowDetailFile';
import { FileWorkflowDetailWorkflow } from './fileWorkflowDetailWorkflow';


export interface FileWorkflowDetail { 
    file: FileWorkflowDetailFile;
    workflow?: FileWorkflowDetailWorkflow;
    steps: Array<FileWorkflowDetailStep>;
    myStep?: FileWorkflowMyStep;
    permissions: FileWorkflowPermissions;
}

